/**
 * Return just the entrypoint of the filesystem.
 */
function getEntrypoint(filesystem) {
    return filesystem?.find((file) => file.isEntrypoint);
}

export { getEntrypoint };
